export const handleSearchRedirect = (redirect, replaceState = false) => {
  if (replaceState) {
    window.history.replaceState({}, null, redirect);
    window.location.reload();
  } else {
    window.location.href = redirect;
  }
};

export const findRuleRedirect = userData => {
  const redirectRule = userData.find(item => Boolean(item.redirect));
  return redirectRule?.redirect ?? null;
};

const useSearchRedirectURL = (searchResults, shouldRedirect = false, shouldReplaceState = false) => {
  const userData = searchResults?.userData ?? [];

  if (userData.length) {
    const redirect = findRuleRedirect(userData);

    if (redirect) {
      // Handle actual redirect here
      if (shouldRedirect) {
        handleSearchRedirect(redirect, shouldReplaceState);
      }

      return redirect;
    }
  }

  return null;
};

export default useSearchRedirectURL;
